// country component
const flagFromCountryCode = (countryCode: string) =>
  `https://cdn.jsdelivr.net/gh/hampusborgos/country-flags@main/svg/${countryCode.toLowerCase()}.svg`;

type Props = {
  countryCode: string;
  width?: number;
  height?: number;
};

const CountryFlag = ({ countryCode, ...rest }: Props) => {
  return (
    <img
      {...rest}
      loading='lazy'
      src={flagFromCountryCode(countryCode)}
      alt={countryCode}
    />
  );
};

export default CountryFlag;
